import {createTextVariant} from './Text.js'

export default createTextVariant('s2', 'S2')
